import whenURLChange from "./helpers/whenURLChange";
import getPageConfig from "./helpers/getPageConfig";
import { sendRequest } from "./helpers/XMLHttpRequest";
import { waitForNodes } from "./helpers/waitForNodes";
import { DL2_SCRIPT_TAG_NAME } from "./helpers/constants";
import {errorLog, ErrorTypes} from "./helpers/error-logger";
import {cookieService} from "./lib/utils/cookieService";
// import { waitForNodes } from "./helpers/waitForNodes";
// import "core-js/fn/promise";

(function dl2Loader() {
  window._dl2 = window._dl2 || { loaded: false };

  const currentScript = document.querySelector(
    'script[src*="dl2"][data-config-src]'
  );
  if (currentScript === null) {
    return;
  }

  const src = currentScript.src || currentScript.getAttribute("src");
  const configSrc =
    currentScript.configSrc || currentScript.getAttribute("data-config-src");
  if (!configSrc) {
    return;
  }

  sendRequest({
    url: configSrc,
    success: onreadystatechange,
    error: () => {
      errorLog({
        level: 'warn',
        type: ErrorTypes.DownloadConfigNotFound,
        countryCode: cookieService.getCookie('country'),
        version: '',
        message: configSrc,
      });
      console.error(`Failed to retrieve dl2 config file.`)}
  });

  function onreadystatechange(response) {
    let config;

    try {
      config = JSON.parse(response.responseText);
    } catch (e) {
      console.error(e);
    }

    // Couldn't parse JSON
    if (config === undefined) {
      return;
    }
    window._dl2.config = { [configSrc]: { then: cb => cb(config) } };

    // When URL changes and there is a config for the current page, then load main dl2.js script
    whenURLChange(function() {
      const { page, pageConfig } = getPageConfig(config);
      if (pageConfig === undefined || window._dl2.loaded === true) {
        return;
      }
      window._dl2.page = page;

      const browsersToUseStaticVersion = ["MSIE 10"];
      const regExpToSearch = new RegExp(
        "(" + browsersToUseStaticVersion.join("|") + ")"
      );
      // if data-core attribute, load core.js
      const core = currentScript.core || currentScript.getAttribute("data-core");
      if (core) {
        const dl2 = document.createElement("script");
        dl2.type = "text/javascript";
        dl2.async = true;
        dl2.src = src
          .split("/")
          .slice(0, -1)
          .concat("dl2.core.js")
          .join("/");
        const s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(dl2, s);
        window._dl2.loaded = true;
        return;
      }

      if (navigator.appVersion.search(regExpToSearch) > -1) {
        applyStaticVersion(pageConfig);
      } else {
        applyLiveVersion();
      }
    });
  }

  function applyStaticVersion(pageConfig) {
    sendRequest({
      url:
        location.origin +
        location.pathname +
        "?static=3394E636-20BC-4B90-B0B0-8D666AA007E7",
      success: success,
      error: () =>
        console.error(`Failed to retrieve static version of the current page.`)
    });

    function success(innerHTML) {
      const doc = new DOMParser().parseFromString(
        innerHTML.response,
        "text/html"
      );
      const selectors = Object.keys(pageConfig);
      selectors.forEach(selector => {
        // Warning! In older browsers waitForNodes returns fake promise-like interface.
        waitForNodes({ selector })
          .then(nodes => {
            nodes[0].innerHTML = "";
            Array.prototype.slice
              .call(doc.querySelectorAll("[data-dl2]"))
              .forEach(function(element) {
                if (element.tagName === DL2_SCRIPT_TAG_NAME.toUpperCase()) {
                  // eslint-disable-next-line
                  new Function(element.textContent)();
                } else {
                  nodes[0].appendChild(element);
                }
              });
          })
          .catch(console.error);
      });
    }
  }

  function applyLiveVersion() {
    // Load main dl2.js script
    const dl2 = document.createElement("script");
    dl2.type = "text/javascript";
    dl2.async = true;
    dl2.src = src
      .split("/")
      .slice(0, -1)
      .concat("dl2.js")
      .join("/");
    const s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(dl2, s);
    window._dl2.loaded = true;
  }
})();
